import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    plans: []
  }),
  mutations: {
    setPlans(state, plans) {
      state.plans = plans;
    }
  },
  actions: {
    async loadPlans({ commit }) {
      try {
        const res = await apiClient('billing.plans');
        if(res?.data) {
          commit('setPlans', res.data);
        }
      } catch (e) {
        console.error('loadPlans error:', e);
        throw e;
      }
    },
    async createInvoice(_, data) {
      try {
        const res = await apiClient('billing.create', data);

        if (!res || !res.success) {
          throw new Error(res?.error || 'Ошибка при создании счёта');
        }

        return res; // ожидаем { url: '...' }
      } catch (e) {
        console.error('createInvoice error:', e);
        throw e;
      }
    }
  }
}
